import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from "react-router-dom";

const mealtypeUrl = "https://zomatourl.herokuapp.com/mealtype";

const QuickSearch = () => {
  const [mealtype, setMealtype] = useState([]);

  useEffect(() => {
    getMealType();
  }, [])

  const getMealType = () => {
    fetch(mealtypeUrl, { method: "GET" })
      .then(res => res.json())
      .then(data => {
        setMealtype(data)
      })
      .catch(err => {
        throw err;
      })
  }

  return (
    <React.Fragment>
      <Container>
        <Row className='quick-search m-3'>
          <h1>Quick Search</h1>
          <p>Discover restaurants by type of meal</p>

          {
            mealtype.map((meal, index) => {
              return (
                <Col sm={12} md={6} lg={4} className="boxes" key={index}>
                    <Link to={`list/${meal.mealtype_id}`} style={{textDecoration : "none"}}>
                  <div className="box d-flex">
                    <div className="img">
                      <img src={meal.meal_image} alt={meal.mealtype} />
                    </div>

                    <div className="desc m-3">
                      <h2>{meal.mealtype}</h2>
                      <h6>{meal.content}</h6>
                    </div>
                  </div>
                </Link>
                </Col>
              )
            })
          }
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default QuickSearch